/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CommissionType {
    Unentgeltlich = 'Unentgeltlich',
    KeinHonorarNurProvision = 'KeinHonorarNurProvision',
    JahreshonorarInEurOhneProvision = 'JahreshonorarInEurOhneProvision',
    JahreshonorarInPercentOhneProvision = 'JahreshonorarInPercentOhneProvision'
  }

    export const CommissionTypeTranslocoMap: Record<CommissionType, string> = {
    [CommissionType.Unentgeltlich]: 'commissionType.unentgeltlich',
    [CommissionType.KeinHonorarNurProvision]: 'commissionType.keinHonorarNurProvision',
    [CommissionType.JahreshonorarInEurOhneProvision]: 'commissionType.jahreshonorarInEurOhneProvision',
    [CommissionType.JahreshonorarInPercentOhneProvision]: 'commissionType.jahreshonorarInPercentOhneProvision',
    };

    export const CommissionTypeOptions = [
  { value: CommissionType.Unentgeltlich, labelKey: 'commissionType.unentgeltlich' },
  { value: CommissionType.KeinHonorarNurProvision, labelKey: 'commissionType.keinHonorarNurProvision' },
  { value: CommissionType.JahreshonorarInEurOhneProvision, labelKey: 'commissionType.jahreshonorarInEurOhneProvision' },
  { value: CommissionType.JahreshonorarInPercentOhneProvision, labelKey: 'commissionType.jahreshonorarInPercentOhneProvision' },
    ];

